export const THEME_COLORS = {
  light: '#000000', // Black for light mode
  dark: '#FFFFFF', // White for dark mode
  spotify: '#04F500', // Bright green for Spotify theme
} as const;

export type ThemeName = keyof typeof THEME_COLORS;
